import { Component, HostListener, OnInit, ViewChild } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { DevExtremeModule } from 'devextreme-angular';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AppInformationService, AuthService, UtilityService } from 'app/core/core.module';
import { confirm, alert } from 'devextreme/ui/dialog';
import validationEngine from 'devextreme/ui/validation_engine';
import _ from 'lodash';
import moment from 'moment';
import { smoothlyMenu } from '../../app.helpers';
declare var jQuery: any;

@Component({
    selector: 'app-nomination',
    templateUrl: './nomination.component.html',
    styleUrls: ['./nomination.component.scss'],
    standalone: true,
    imports: [DevExtremeModule],
})
export class NominationComponent implements OnInit {
    members: any;
    currentCouncil: any;
    endDate: any;
    today = new Date();

    filter: {
        email: string;
        userCode: string;
    };
    codeFilter: {
        email: string;
        budgetBox: string;
        birthDate: Date;
    };
    dateString: string;
    processing = false;
    validationGroup = 'mainValidation';
    codeFilterOptions: any;
    userCode: any;
    proposalInfo: any;
    voteClosed = false;
    screenHeight: number;
    screenWidth: number;
    canDiscuss = false;
    discussion: string;
    discussions: any;

    deacons: any[];
    sheps: any;
    execs: any;
    requiredDeacons = 4;
    requiredShepherding = 4;
    requiredExecutive = 3;
    canVote = false;
    voteExpired = false;
    nominationExceptions: NominationException[] = [];
    constructor(
        private utility: UtilityService,
        private appInfo: AppInformationService,
        private router: Router,
        private auth: AuthService,
        private route: ActivatedRoute,
    ) {
        // this.getScreenSize();
    }
    // toggleNavigation(): void {
    //     jQuery('body').toggleClass('mini-navbar');
    //     smoothlyMenu();
    // }

    // @HostListener('window:resize', ['$event'])
    // getScreenSize(event?) {
    //     this.screenHeight = window.innerHeight;
    //     this.screenWidth = window.innerWidth;
    //     // console.log(this.screenHeight, this.screenWidth);
    // }

    async ngOnInit() {
        const result = (await this.utility.getNominationInfos()) as any;
        if (result.settings.length > 0) {
            this.requiredDeacons = _.find(result.settings, { Name: 'RequiredDeacons' }).IntValue + 1;
            this.requiredExecutive = _.find(result.settings, { Name: 'RequiredExecutiveElders' }).IntValue + 1;
            this.requiredShepherding = _.find(result.settings, { Name: 'RequiredShepherdingElders' }).IntValue + 1;
        }

        this.deacons = [];
        for (let index = 0; index < this.requiredDeacons; index++) {
            const nom = new NominationInfo();
            nom.role = 'Deacon';
            this.deacons.push(nom);
        }

        this.sheps = [];
        for (let index = 0; index < this.requiredShepherding; index++) {
            const nom = new NominationInfo();
            nom.role = 'Shepherding Elder';
            this.sheps.push(nom);
        }

        this.execs = [];
        for (let index = 0; index < this.requiredExecutive; index++) {
            const nom = new NominationInfo();
            nom.role = 'Executive Elder';
            this.execs.push(nom);
        }
        this.userCode = this.route.snapshot.params['id'];
        this.appInfo.pleaseWaitShow();
        try {
            await this.getData();
            await this.loadNominationExceptions();
        } catch (error) {}
        this.appInfo.pleaseWaitHide();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const result = (await this.utility.getMemberList(this.userCode)) as any;
        this.members = result.list;
        this.canVote = result.canVote;

        this.currentCouncil = result.currentList;
        this.currentCouncil.forEach((x) => {
            x.ending = x.EndDate ? moment(x.EndDate).format('YYYY') : 'Current';
        });
        this.currentCouncil = _.orderBy(this.currentCouncil, ['ending', 'Committee', 'Name']);
        this.endDate = moment(result.EndDate).format('MM/DD/YYYY');

        this.proposalInfo = [];
        this.proposalInfo.voteDate = result.Voted ? moment(result.Voted).format('MM/DD/YYYY') : null;
        this.voteExpired = moment(result.EndDate).startOf('day').toDate() < new Date();
    }

    async loadNominationExceptions() {
        try {
            const result = (await this.utility.getNominationExceptions()) as NominationException[];
            this.nominationExceptions = result || [];
        } catch (error) {
            console.error('Error loading nomination exceptions:', error);
            this.nominationExceptions = [];
        }
    }

    async submit() {
        const noNominationCheck = await this.noNominationCheck();
        if (!noNominationCheck) return;

        const duplicateCheck = await this.nominationCheck();
        if (!duplicateCheck) return;

        const exceptionCheck = await this.nominationExceptionCheck();
        if (!exceptionCheck) return;

        const result = await confirm(`Are you ready to Submit?  This is your one time nomination.`, `${this.appInfo.settings.church.toUpperCase()}`);
        if (!result) return;
        this.appInfo.pleaseWaitShow();

        const vote = await this.utility.submitNominations(this.userCode, this.deacons, this.sheps, this.execs);
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async noNominationCheck() {
        const deacons = this.deacons.filter((x) => {
            return !!x.id;
        }).length;
        const sheps = this.sheps.filter((x) => {
            return !!x.id;
        }).length;
        const execs = this.execs.filter((x) => {
            return !!x.id;
        }).length;
        if (!deacons && !sheps && !execs) {
            await alert(`No nominations selected`, `${this.appInfo.settings.church.toUpperCase()}`);
            return false;
        } else return true;
    }

    async nominationCheck(): Promise<boolean> {
        let nominationList = this.deacons.filter((x) => {
            return !!x.id;
        });
        let nominationCheck = _.uniqBy(nominationList, 'id').length;
        if (nominationCheck !== nominationList.length) {
            await alert(`Duplicate Deacon`, `${this.appInfo.settings.church.toUpperCase()}`);
            return false;
        }

        nominationList = this.sheps.filter((x) => {
            return !!x.id;
        });
        nominationCheck = _.uniqBy(nominationList, 'id').length;
        if (nominationCheck !== nominationList.length) {
            await alert(`Duplicate Shepherding Elder`, `${this.appInfo.settings.church.toUpperCase()}`);
            return false;
        }

        nominationList = this.execs.filter((x) => {
            return !!x.id;
        });
        nominationCheck = _.uniqBy(nominationList, 'id').length;
        if (nominationCheck !== nominationList.length) {
            await alert(`Duplicate Executive Elder`, `${this.appInfo.settings.church.toUpperCase()}`);
            return false;
        }
        return true;
    }

    async nominationExceptionCheck(): Promise<boolean> {
        // Check each nomination category for exceptions
        const allNominations = [
            ...this.deacons.filter((x) => !!x.id).map((x) => ({ ...x, position: 'Deacon' })),
            ...this.sheps.filter((x) => !!x.id).map((x) => ({ ...x, position: 'Shepherding Elder' })),
            ...this.execs.filter((x) => !!x.id).map((x) => ({ ...x, position: 'Executive Elder' })),
        ];

        const exceptionsFound = [];

        for (const nomination of allNominations) {
            const exception = this.nominationExceptions.find((ex) => !ex.Deleted && ex.PersonId === nomination.id && ex.Position === nomination.position);

            if (exception) {
                const memberName = this.members.find((m) => m.Value === nomination.id)?.Text || 'Unknown';
                exceptionsFound.push({
                    personName: exception.PersonName,
                    position: nomination.position,
                    exception: exception.Exception,
                });
            }
        }

        if (exceptionsFound.length > 0) {
            let message = 'The following nominations have exceptions:\n\n';
            exceptionsFound.forEach((ex) => {
                message += `<br>• ${ex.personName} (${ex.position}): ${ex.exception}\n`;
            });
            message += '<br><br>\r\nPlease review your nominations and make the necessary changes.';

            await this.utility.logRecord(
                this.userCode,
                `Nomination Exception: ${exceptionsFound.map((ex) => `${ex.personName} (${ex.position})`).join('; ')}`,
            );

            await alert(message, `${this.appInfo.settings.church.toUpperCase()}`);
            return false;
        }

        return true;
    }

    clear() {
        this.deacons.forEach((x) => {
            x.id = null;
        });
        this.sheps.forEach((x) => {
            x.id = null;
        });
        this.execs.forEach((x) => {
            x.id = null;
        });
    }

    getCurrentMembers() {
        if (!this.currentCouncil) return [];
        return this.currentCouncil.filter((member) => this.isCurrentMember(member));
    }

    getPreviousMembers() {
        if (!this.currentCouncil) return [];
        return this.currentCouncil.filter((member) => !this.isCurrentMember(member));
    }

    private isCurrentMember(member: any): boolean {
        // Members with "Current" as ending or future year are considered current
        return member.ending === 'Current' || (member.ending !== 'Current' && parseInt(member.ending) >= this.today.getFullYear());
    }
}

class NominationInfo {
    id: number;
    role: string;
}

interface NominationException {
    Position: string; // 'Deacon', 'Shepherding Elder', 'Executive Elder'
    PersonId: number;
    PersonName: string;
    Exception: string; // The exception message like "A family member is currently serving on the selected position"
    Deleted: boolean;
}
